export default __webpack_public_path__ + "img/rJWrlnMk.d25eed0b.svg";